import { cn } from "../../utils/lib";

const ErrorMsg = ({
    text,
    className,
}: {
    text: string;
    className?: string;
}) => {
    return (
        <div
            id="error"
            className={cn("mt-1 text-[10px] text-red-500 2xl:text-xs", className)}
        >
            {text}
        </div>
    );
};

export { ErrorMsg };

